import script from "./VirtualControllerItem.vue?vue&type=script&setup=true&lang=js"
export * from "./VirtualControllerItem.vue?vue&type=script&setup=true&lang=js"

import "./VirtualControllerItem.vue?vue&type=style&index=0&id=60bf5890&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60bf5890"]])

export default __exports__